import {t as baseT} from '@eitje/bridge'
import {Title} from '../text'
import {useModalContext} from './modal_context'
import {DocsButton} from '../eitje_button'
import './styles/header.less'
import {Icon} from '../icon'

export const ModalHeader = props => {
	const {RightHeader = Cross, RightHeaderProps = {}} = props
	return (
		<div className="eitje-modal-2-header">
			<div className="eitje-modal-2-header-left">
				<ModalLeftHeader {...props} />
			</div>
			<div className="eitje-modal-2-header-right">{RightHeader && <RightHeader {...props} children={null} {...RightHeaderProps} />}</div>
		</div>
	)
}

const Cross = () => {
	const {onCancel} = useModalContext()
	return <Icon name="cross" onClick={onCancel} />
}

const ModalLeftHeader = props => {
	const {title, LeftHeader, subtitle, docsUrl} = props
	const {t} = useModalContext()
	const subText = subtitle == true ? t('subtitle') : subtitle

	const _title = title || t('title')

	return (
		<>
			<div className="eitje-modal-2-left-header-titles">
				<Title truncate>{_title}</Title>
				{LeftHeader && <LeftHeader />}
				{!!subtitle && (
					<h5 className="eitje-modal-2-subtitle" style={{flexShrink: 0, marginRight: '12px'}}>
						{subText}
					</h5>
				)}
			</div>

			{docsUrl && (
				<DocsButton height="mini" to={docsUrl}>
					{t('docs_title', baseT('learnMore'))}
				</DocsButton>
			)}
		</>
	)
}
